const facilities = [
  {
    name: "Fairbanks Main Post Office",
    address: "315 Barnette St, Fairbanks, AK 99701",
    phone: "(907) 452-3223",
    hours: "Mon–Fri 8:30am–5:00pm",
    note: "Primary passport acceptance for Fairbanks; photo services on site",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Airport Way Post Office",
    address: "3101 Airport Way, Fairbanks, AK 99709",
    phone: "(907) 474-1284",
    hours: "Mon–Fri 9:00am–5:00pm",
    note: "Serving west Fairbanks and College area",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Fairbanks North Star Borough Clerk",
    address: "809 Pioneer Rd, Fairbanks, AK 99701",
    phone: "(907) 459-1401",
    hours: "Mon–Fri 8:00am–5:00pm",
    note: "Borough acceptance facility",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "North Pole Post Office",
    address: "125 St Nicholas Dr, North Pole, AK 99705",
    phone: "(907) 488-2823",
    hours: "Mon–Fri 9:00am–5:00pm",
    note: "Serving North Pole and Badger Road residents",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Fairbanks City Hall Clerk",
    address: "800 Cushman St, Fairbanks, AK 99701",
    phone: "(907) 459-6700",
    hours: "Mon–Fri 8:00am–4:30pm",
    note: "Downtown Fairbanks acceptance location",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Eielson AFB Legal Office",
    address: "517 Hangar Ave, Eielson AFB, AK 99702",
    phone: "(907) 377-1843",
    hours: "Mon–Fri 8:00am–4:00pm",
    note: "Serving active duty, dependents, and eligible civilians",
    website: "https://tools.usps.com/find-location.htm",
  },
];

export default function AcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Fairbanks
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            First-time applicants (and those who can&apos;t mail-renew) need to visit an acceptance facility in person. Here are the main locations near Fairbanks.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {facilities.map((f, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
                <i className="ri-government-line text-[#1A365D] text-lg"></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{f.name}</h3>
              <p className="text-gray-500 text-xs mb-1 flex items-start gap-1.5">
                <i className="ri-map-pin-line mt-0.5 flex-shrink-0 text-[#F6C344]"></i>
                {f.address}
              </p>
              <p className="text-gray-500 text-xs mb-1 flex items-center gap-1.5">
                <i className="ri-phone-line flex-shrink-0 text-[#F6C344]"></i>
                {f.phone}
              </p>
              <p className="text-gray-500 text-xs mb-1 flex items-center gap-1.5">
                <i className="ri-time-line flex-shrink-0 text-[#F6C344]"></i>
                {f.hours}
              </p>
              <p className="text-gray-500 text-xs mb-1 flex items-center gap-1.5">
                <i className="ri-global-line flex-shrink-0 text-[#F6C344]"></i>
                <a
                  href={f.website}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2"
                >
                  Visit website
                </a>
              </p>
              {f.note && (
                <p className="text-gray-400 text-xs mt-3 pt-3 border-t border-gray-100">{f.note}</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#1A365D] rounded-lg p-6 text-center">
          <p className="text-white/80 text-sm mb-2">
            Skip the acceptance facility line — if you&apos;re eligible to renew by mail, Fast Passport Center handles everything remotely.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap mt-3"
          >
            Check My Eligibility <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}